import useIsDesktop from "@hooks/useIsDesktop"
import useRouter from "@hooks/useRouter"

import { faIcon } from "@utils/faIcon"
import isModKeyPressed from "@utils/isModKeyPressed"

import { Button, IconButton, Tooltip } from "@atoms"

import { NavTopBarCTAButtonProps } from "./NavTopBarCTAButton.types"

export default function NavTopBarCTAButton(props: NavTopBarCTAButtonProps) {
    const { destination, onClick } = props

    const router = useRouter()

    const isDesktop = useIsDesktop()

    const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (onClick) {
            onClick(event)
        } else if (isModKeyPressed(event)) {
            window.open(destination, "_blank", "noopener,noreferrer")
        } else {
            router.push(destination)
        }
    }

    if (isDesktop) {
        return (
            <Button
                size="lg"
                variant="solid"
                leftIcon={faIcon({ name: "plus", style: "regular" })}
                onClick={handleClick}
                noDebounce={true}
            >
                New
            </Button>
        )
    } else {
        return (
            <Tooltip body="New" wrapChildren={false}>
                <IconButton
                    size="lg"
                    variant="solid"
                    icon={faIcon({ name: "plus", style: "regular" })}
                    onClick={handleClick}
                    aria-label="New"
                    noDebounce={true}
                />
            </Tooltip>
        )
    }
}
